import React, { useEffect, useRef, useState } from 'react'
import { fetchVisitorInfoData } from '../../lib/VisitorInfo/fetchVisitorInfoData'
import { AdvisorData } from '../../types/AdvisorData.type'
import xss from 'xss'

export type PersonalizedProspectDropdownProps = {
  children?: React.ReactNode
  isEnabled?: boolean
  testId?: string
}

export const PersonalizedProspectDropdown: React.FC<
  PersonalizedProspectDropdownProps
> = props => {
  const { isEnabled, children, testId } = props
  const [advisorData, setAdvisorData] = useState<AdvisorData | null>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchVisitorInfoData()
      const data =
        result?.visitor?.targetingData?.advisorcollector?.extraData?.attributes
      setAdvisorData({
        image: data?.image,
        name: data?.name,
        phonenumber: data?.phonenumber,
        tagline: data?.tagline,
        url: data?.url,
        email: data?.email
      })
    }
    if (isEnabled) {
      fetchData()
    }
  }, [])

  const handleOpenClick = () => {
    setIsOpen(true)
  }

  const handleBlur = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    timerRef.current = setTimeout(() => {
      setIsOpen(false)
    }, 1000)
  }

  const handleFocus = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
  }

  if (!isEnabled || !advisorData) {
    return children
  }

  return (
    <nav
      id="personalized-sticky-advisor"
      className={`PersonalizedProspectDropdown ${isOpen ? 'is-open' : ''}`}
      data-testid={testId}
      onMouseEnter={handleFocus}
      onMouseLeave={handleBlur}
    >
      <button
        id="personalized-button"
        className="Button Button--primary Button--small"
        tabIndex={-1}
        onClick={handleOpenClick}
      >
        Contact {advisorData?.name ?? ''}
      </button>
      <ul className="List List--selectable u-paddingLeft0 u-posAbsolute u-bgColorWhite">
        {advisorData?.url && (
          <li className="List-item u-padding0 u-border0">
            <a className="Link" href={xss(advisorData?.url)}>
              Request consultation
            </a>
          </li>
        )}
        {advisorData?.email && (
          <li className="List-item u-padding0 u-border0">
            <a className="Link" href={`mailto:${xss(advisorData?.email)}`}>
              Email {xss(advisorData?.name ?? '')}
            </a>
          </li>
        )}
        {advisorData?.phonenumber && (
          <li className="List-item u-padding0 u-border0">
            <a className="Link" href={`tel:${xss(advisorData?.phonenumber)}`}>
              Call {xss(advisorData?.name ?? '')}
            </a>
          </li>
        )}
      </ul>
    </nav>
  )
}
